import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { STRIPE_PK } from '../../../commons/Const'
import Logo, { LogoType } from '../../components/atoms/Logo/Logo'
import ConfirmPaymentForm from '../../components/organisms/ConfirmPaymentForm/ConfirmPaymentForm'
import CompletePayment from '../../components/organisms/CompletePayment/CompletePayment'
import ImageAsset, { ImageAssetType } from '../../components/atoms/ImageAsset/ImageAsset'
import {
  SELECT_PLAN,
  COMPLETE_CREATE_TOKEN,
  FIX_PAYMENT_FORM,
  CHANGE_PAYMENT_FORM,
  POST_PAYMENT,
  NEXT_TO_PAYMENT_FORM
} from '../../actions/authActions'
import './PaymentPage.css'
import CommonFooter from '../../components/organisms/CommonFooter/CommonFooter'
import PaymentForm from '../../components/organisms/PaymentForm/PaymentForm'
import { isEmptyObject } from '../../../commons/formValidator'
import PlanCard from '../../components/molecules/PlanCard/PlanCard'
import { Plan } from '../../../commons/Plan'
import Button from '../../components/atoms/Button/Button'

export const PaymentPageType = {
  SELECT_PLAN: 1,
  INPUT_FORM: 2,
  CONFIRM: 3,
  COMPLETE: 4
}

class PaymentPage extends PureComponent {
  constructor(props) {
    super(props)
    this.state = { stripe: null }
  }

  componentDidMount() {
    if (window.Stripe) {
      this.setState({ stripe: window.Stripe(STRIPE_PK) })
    } else {
      document.querySelector('#stripe-js').addEventListener('load', () => {
        this.setState({ stripe: window.Stripe(STRIPE_PK) })
      })
    }
  }

  render() {
    const {
      selectPlan,
      nextToPaymentForm,
      paymentPlan,
      handleChangeForm,
      pageType,
      firstName,
      familyName,
      completeCreateToken,
      cardLast4,
      fixPaymentForm,
      postPayment,
      isLoading,
      confirmError,
      inputFormErrors,
      completeCreditCard,
      selectedDateOption,
      eventDate,
      selectedRefererOption,
      otherReferer
    } = this.props

    const handleChange = input => {
      const data = {
        firstName,
        familyName,
        completeCreditCard,
        selectedDateOption,
        eventDate,
        selectedRefererOption,
        otherReferer,
        ...input
      }
      handleChangeForm(data)
    }
    let title = '購入情報の入力'
    let content = (
      <PaymentForm
        stripe={this.state.stripe}
        firstName={firstName}
        familyName={familyName}
        plan={paymentPlan}
        selectedDateOption={selectedDateOption}
        eventDate={eventDate}
        selectedRefererOption={selectedRefererOption}
        otherReferer={otherReferer}
        handleChangeForm={handleChange}
        completeInputForm={isEmptyObject(inputFormErrors)}
        formErrorMessage={inputFormErrors}
        completeCreateToken={completeCreateToken}
      />
    )
    switch (pageType) {
      case PaymentPageType.SELECT_PLAN:
        title = 'プランの選択'
        content = (
          <React.Fragment>
            <div styleName="plan-card" onClick={() => selectPlan(Plan.LIGHT)}>
              <PlanCard plan={Plan.LIGHT} isSelected={paymentPlan === Plan.LIGHT} />
            </div>
            <div styleName="plan-card" onClick={() => selectPlan(Plan.SAFETY)}>
              <PlanCard plan={Plan.SAFETY} isSelected={paymentPlan === Plan.SAFETY} />
            </div>
            <div styleName="select-plan-button">
              <Button handleClick={() => nextToPaymentForm()} isAccent isEnabled={!!paymentPlan}>
                <p>次へ</p>
              </Button>
            </div>
          </React.Fragment>
        )
        break

      case PaymentPageType.CONFIRM:
        title = 'お支払い内容の確認'
        content = (
          <ConfirmPaymentForm
            firstName={firstName}
            familyName={familyName}
            cardLast4={cardLast4}
            plan={paymentPlan}
            selectedDateOption={selectedDateOption}
            eventDate={eventDate}
            selectedRefererOption={selectedRefererOption}
            otherReferer={otherReferer}
            isLoading={isLoading}
            handleClickFixLink={fixPaymentForm}
            handleClickPayment={postPayment}
            error={confirmError}
          />
        )
        break

      case PaymentPageType.COMPLETE:
        title = 'お支払いが完了しました'
        content = <CompletePayment />
        break
    }
    return (
      <div styleName="background">
        <div styleName="container">
          <div styleName="backgroudImage">
            <ImageAsset type={ImageAssetType.TOP_VISUAL} />
          </div>
          <div styleName="mainContent">
            <div styleName="titlePart">
              <div styleName="logo">
                <Logo type={LogoType.GRAY} />
              </div>
              <h1 styleName="title">{title}</h1>
            </div>
            {content}
          </div>
        </div>
        <CommonFooter />
      </div>
    )
  }
}

PaymentPage.propTypes = {
  // state
  pageType: PropTypes.number.isRequired,
  email: PropTypes.string.isRequired,
  password: PropTypes.string.isRequired,
  firstName: PropTypes.string.isRequired,
  familyName: PropTypes.string.isRequired,
  completeCreditCard: PropTypes.bool.isRequired,
  inputFormErrors: PropTypes.object,
  cardLast4: PropTypes.string,
  isLoading: PropTypes.bool.isRequired,
  completeInputForm: PropTypes.bool.isRequired,
  confirmError: PropTypes.string,
  paymentPlan: PropTypes.number,
  selectedDateOption: PropTypes.string,
  eventDate: PropTypes.string,
  selectedRefererOption: PropTypes.string,
  otherReferer: PropTypes.string,
  // dispatch
  handleChangeForm: PropTypes.func.isRequired,
  completeCreateToken: PropTypes.func.isRequired,
  fixPaymentForm: PropTypes.func.isRequired,
  postPayment: PropTypes.func.isRequired,
  selectPlan: PropTypes.func.isRequired,
  nextToPaymentForm: PropTypes.func.isRequired
}

const mapStateToProps = state => ({
  firstName: state.auth.paymentFirstName,
  familyName: state.auth.paymentFamilyName,
  completeCreditCard: state.auth.paymentCompleteCreditCard,
  pageType: state.auth.paymentPageType,
  inputFormErrors: state.auth.paymentInputFormErrors,
  cardLast4: state.auth.cardLast4,
  isLoading: state.auth.isPaymentLoading,
  completeInputForm: state.auth.completeInputForm,
  confirmError: state.auth.confirmError,
  paymentPlan: state.auth.paymentPlan,
  selectedDateOption: state.auth.paymentSelectedDateOption,
  eventDate: state.auth.paymentEventDate,
  selectedRefererOption: state.auth.paymentSelectedRefererOption,
  otherReferer: state.auth.paymentOtherReferer
})

const mapDispatchToProps = dispatch => ({
  handleChangeForm: data => dispatch(CHANGE_PAYMENT_FORM(data)),
  completeCreateToken: data => dispatch(COMPLETE_CREATE_TOKEN(data)),
  fixPaymentForm: () => dispatch(FIX_PAYMENT_FORM()),
  postPayment: () => dispatch(POST_PAYMENT()),
  selectPlan: plan => dispatch(SELECT_PLAN({ plan })),
  nextToPaymentForm: () => dispatch(NEXT_TO_PAYMENT_FORM())
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PaymentPage)
